__turbopack_context__.v({
  "animate": "CQEX2a_animate",
  "cta-button": "CQEX2a_cta-button",
  "dark": "CQEX2a_dark",
  "light": "CQEX2a_light",
});
